/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1PersonIdAddressesAddresspersonidMutationRequest,
  PutApiV1PersonIdAddressesAddresspersonidMutationResponse,
  PutApiV1PersonIdAddressesAddresspersonidPathParams,
  PutApiV1PersonIdAddressesAddresspersonid400,
  PutApiV1PersonIdAddressesAddresspersonid401,
  PutApiV1PersonIdAddressesAddresspersonid404,
  PutApiV1PersonIdAddressesAddresspersonid500,
} from "../../types/personRegisterController/PutApiV1PersonIdAddressesAddresspersonid.ts";

function getPutApiV1PersonIdAddressesAddresspersonidUrl(
  id: PutApiV1PersonIdAddressesAddresspersonidPathParams["id"],
  addressPersonId: PutApiV1PersonIdAddressesAddresspersonidPathParams["addressPersonId"],
) {
  const res = {
    method: "PUT",
    url: `/api/v1/person/${id}/addresses/${addressPersonId}` as const,
  };
  return res;
}

/**
 * @description Atualiza os dados de um endereço vinculado à pessoa. **(Requer Authorization para autenticação)**
 * @summary Atualizar endereço da pessoa (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/addresses/:addressPersonId}
 */
export async function putApiV1PersonIdAddressesAddresspersonid(
  id: PutApiV1PersonIdAddressesAddresspersonidPathParams["id"],
  addressPersonId: PutApiV1PersonIdAddressesAddresspersonidPathParams["addressPersonId"],
  data?: PutApiV1PersonIdAddressesAddresspersonidMutationRequest,
  config: Partial<
    RequestConfig<PutApiV1PersonIdAddressesAddresspersonidMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutApiV1PersonIdAddressesAddresspersonidMutationResponse,
    ResponseErrorConfig<
      | PutApiV1PersonIdAddressesAddresspersonid400
      | PutApiV1PersonIdAddressesAddresspersonid401
      | PutApiV1PersonIdAddressesAddresspersonid404
      | PutApiV1PersonIdAddressesAddresspersonid500
    >,
    PutApiV1PersonIdAddressesAddresspersonidMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1PersonIdAddressesAddresspersonidUrl(
      id,
      addressPersonId,
    ).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
